import React, { Component } from 'react';


class JobInfoBox extends Component {
    state = {}
    render() { 
        return ( 
            <div className="col-xl-6">
                <div className="whiteBackground paddingTen">
                    <h3 className="miniHeadings">{this.props.title}</h3>
                    <div className="text-center">
                        <h3>{this.props.bodyTitle}</h3>
                        <p>{this.props.body}</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default JobInfoBox;


// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/JobStatus/JobInfoBox.jsx